import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaArrowLeft,
  FaHeadset,
  FaComments,
  FaClock,
  FaChevronDown,
  FaChevronUp,
  FaLifeRing,
} from "react-icons/fa";

import "./CustomerCare.css";


const FAQS = [
  {
    question: "How do I deposit money?",
    answer:
      "Open the Deposit section, select your preferred payment method, enter the amount and follow the instructions shown on the screen.",
  },

  {
    question: "How do I withdraw money?",
    answer:
      "Open the Withdrawal section, choose your withdrawal method, enter the amount and confirm your request. Make sure your payment details are correct.",
  },

  {
    question:
      "My deposit has not arrived. What should I do?",
    answer:
      "First check your transaction history. If the transaction is still pending, please contact support and provide your transaction reference or payment details.",
  },

  {
    question: "My withdrawal is pending.",
    answer:
      "Some withdrawals may require additional processing time. Check your withdrawal history first. If it remains pending for too long, contact support.",
  },

  {
    question: "How do I contact support?",
    answer:
      "Click any LiveChat button to open our customer support chat.",
  },

  {
    question: "I have a problem with my bet.",
    answer:
      "Please contact support and provide your username, bet ID and a short description of the problem so the support team can investigate.",
  },
];


const CustomerCare = () => {

  const navigate = useNavigate();

  const [openFaq, setOpenFaq] = useState(null);


  /* =========================================================
     OPEN CHAT
  ========================================================= */

  const openChat = () => {

    navigate("/support/chat");

  };


  /* =========================================================
     FAQ
  ========================================================= */

  const toggleFaq = (index) => {

    setOpenFaq((previous) =>
      previous === index
        ? null
        : index
    );

  };


  return (

    <div className="support-wrapper">


      {/* HEADER */}

      <header className="support-header">

        <button
          type="button"
          className="support-back"
          onClick={() => navigate(-1)}
        >

          <FaArrowLeft />

          <span>
            Back
          </span>

        </button>


        <div className="support-title">

          <div className="support-title-icon">
            <FaHeadset />
          </div>

          <div>

            <span>
              BFC
            </span>

            <h1>
              Support
            </h1>

          </div>

        </div>


        <div className="support-header-status">

          <span className="support-status-dot" />

          <span>
            Online
          </span>

        </div>

      </header>


      {/* HERO */}

      <section className="support-hero">

        <div className="support-hero-icon">
          <FaHeadset />
        </div>


        <div className="support-hero-content">

          <span>
            NEED HELP?
          </span>

          <h2>
            We're here to help you
          </h2>

          <p>
            Chat directly with our support
            team for assistance with your
            account, deposits, withdrawals,
            bets and other issues.
          </p>


          <button
            type="button"
            className="support-chat-button"
            onClick={openChat}
          >

            <FaComments />

            <span>
              Chat with Support
            </span>

          </button>

        </div>


        <div className="support-hero-decoration">
          <FaComments />
        </div>

      </section>


      {/* OPTIONS */}

      <section className="support-options">


        <div className="support-option-card">

          <div className="support-option-icon">
            <FaComments />
          </div>


          <div>

            <span>
              LIVE CHAT
            </span>

            <strong>
              Chat with us
            </strong>

            <small>
              Get help directly from
              our support team.
            </small>

          </div>


          <button
            type="button"
            onClick={openChat}
          >
            Open
          </button>

        </div>


        <div className="support-option-card">

          <div className="support-option-icon">
            <FaClock />
          </div>


          <div>

            <span>
              SUPPORT HOURS
            </span>

            <strong>
              Available Online
            </strong>

            <small>
              Our support team is available
              through LiveChat.
            </small>

          </div>

        </div>

      </section>


      {/* FAQ */}

      <section className="support-section">

        <div className="support-section-heading">

          <span>
            SUPPORT CENTER
          </span>

          <h2>
            How can we help?
          </h2>

          <p>
            Select a question below to
            find a quick answer.
          </p>

        </div>


        <div className="support-faq-list">

          {FAQS.map((faq, index) => {

            const isOpen =
              openFaq === index;


            return (

              <div
                key={faq.question}
                className={
                  isOpen
                    ? "support-faq open"
                    : "support-faq"
                }
              >

                <button
                  type="button"
                  className="support-faq-question"
                  onClick={() =>
                    toggleFaq(index)
                  }
                >

                  <span className="support-faq-number">

                    {String(index + 1).padStart(2, "0")}

                  </span>


                  <span className="support-faq-text">

                    {faq.question}

                  </span>


                  <span className="support-faq-arrow">

                    {isOpen ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}

                  </span>

                </button>


                {isOpen && (

                  <div className="support-faq-answer">

                    <p>
                      {faq.answer}
                    </p>

                  </div>

                )}

              </div>

            );

          })}

        </div>

      </section>


      {/* CONTACT */}

      <section className="support-contact">

        <div className="support-contact-icon">
          <FaLifeRing />
        </div>


        <div className="support-contact-content">

          <span>
            STILL NEED HELP?
          </span>

          <h2>
            Contact our support team
          </h2>

          <p>
            If you cannot find the answer
            you are looking for, start a
            live conversation with our
            support team.
          </p>

        </div>


        <button
          type="button"
          className="support-contact-button"
          onClick={openChat}
        >

          <FaComments />

          Contact Support

        </button>

      </section>


      {/* FOOTER */}

      <footer className="support-footer">

        <strong>
          BFC SUPPORT
        </strong>

        <span>
          We're here to help you.
        </span>

      </footer>

    </div>

  );

};


export default CustomerCare;
